import script from "./PaymentHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentHistoryView.vue?vue&type=style&index=0&id=629b2ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629b2ec0"]])

export default __exports__